import {Stack} from "@mui/material";
import type {Property} from "csstype";
import type {ReactNode} from "react";
import {LoggedInHeader} from "@/components/Navigation/LoggedInHeader.tsx";
import MainDisplayContainer from "./Layout/MainDisplayContainer";

type Props = {
    children: ReactNode;
    maxWidth?: Property.MaxWidth;
};

const StandardPage = ({children, maxWidth}: Props) => {
    return (
        <Stack sx={{flexDirection: "column", height: "100vh"}}>
            <LoggedInHeader />
            <MainDisplayContainer maxWidth={maxWidth}>{children}</MainDisplayContainer>
        </Stack>
    );
};

export default StandardPage;
